export enum ScreeningQueryParamsEnum {
  search = 'search',
  page = 'page',
  sortBy = 'sortBy',
  status = 'status',
  pageSize = 'pageSize',
  assignedTo = 'assignedTo',
  sortDirection = 'sortDirection',
  includeInstalled = 'includeInstalled',
  includeFutureContactDate = 'includeFutureContactDate',
}
